<template>
  <div class="tx-list-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Contabilidad / Facturación de Reembolso</p>
            <h1 class="list-title">Facturación de Reembolso</h1>
            <p class="list-subtitle">
              Pagos que Transit adelanta por cuenta del cliente, con sus
              comprobantes y su solicitud de reembolso.
            </p>
          </div>
        </v-flex>

        <v-flex xs12>
          <tx-filter @search="onSearch" @download="onDownload"></tx-filter>
        </v-flex>

        <v-flex xs12>
          <v-card class="tx-card">
            <div class="tx-toolbar">
              <div class="tx-toolbar__info">
                <span class="tx-chip">
                  <v-icon small class="tx-chip__icon">receipt_long</v-icon>
                  {{ meta.totalGroups }} trámites
                  <template v-if="meta.totalInvoices !== meta.totalGroups">
                    ({{ meta.totalInvoices }} facturas)
                  </template>
                </span>
                <span v-if="totalPagina" class="tx-chip tx-chip--warn">
                  <v-icon small class="tx-chip__icon">payments</v-icon>
                  B/. {{ money(totalPagina) }} adelantado en esta página
                </span>
              </div>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div class="table-wrap">
                <table class="tx-table">
                  <thead>
                    <tr>
                      <th class="th-center">Estado</th>
                      <th># Factura</th>
                      <th class="th-right">Monto CIF (USD)</th>
                      <th>Laboratorio</th>
                      <th>Distribuidor</th>
                      <th>Fecha de Aprobación</th>
                      <th class="th-right">Monto de Impuestos</th>
                      <th class="th-center">Conceptos</th>
                      <th class="th-right">Total Reembolso</th>
                      <th class="th-center">Paga Transit</th>
                      <th>Fecha de factura</th>
                      <th class="th-actions">Detalle</th>
                    </tr>
                  </thead>
                  <!-- Un <tbody> por trámite: la banda con el consecutivo y,
                       debajo, una fila por factura. Es el mismo patrón de
                       filas agrupadas de todas las listas de Transit
                       (tx-group-row), con el texto de la banda del mixin
                       TramiteBand; el grupo entero abre el detalle. -->
                  <tbody
                    v-for="g in groups"
                    :key="g.key"
                    class="tx-group"
                    @click="openDetail(g.tramite)"
                  >
                    <tr
                      class="tx-group-row"
                      :class="{ 'tx-group-row--single': !esConsolidado(g) }"
                    >
                      <td colspan="12">
                        <v-icon small class="tx-group-row__icon">
                          {{ esConsolidado(g) ? 'layers' : 'description' }}
                        </v-icon>
                        {{ etiquetaTramite(g) }}
                        <strong>{{ consecutivoDe(g) }}</strong>
                        &middot; {{ facturasDe(g) }}
                        <span
                          v-if="esConsolidado(g)"
                          class="tx-group-row__muted"
                        >
                          &middot; CIF total {{ money(cifTramiteDe(g)) }}
                        </span>
                        <span v-if="controlFdDe(g)" class="tx-group-row__muted">
                          &middot; Control F&amp;D: {{ controlFdDe(g) }}
                        </span>
                      </td>
                    </tr>

                    <!-- Una fila por factura. Lo que es del TRÁMITE (semáforo,
                         fechas, impuesto, conceptos, total, switch y detalle)
                         va una sola vez, en la primera fila, y abarca las
                         demás con rowspan: así nada se repite. -->
                    <tr
                      v-for="(inv, i) in g.invoices"
                      :key="inv.id"
                      :class="{ 'tx-child-row': esConsolidado(g) }"
                    >
                      <!-- Semáforo: rojo hasta adjuntar la factura de reembolso -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <span
                              class="light"
                              :class="
                                g.tramite.reimbursementInvoiceDate
                                  ? 'light--green'
                                  : 'light--red'
                              "
                            ></span>
                          </template>
                          <span>
                            {{
                              g.tramite.reimbursementInvoiceDate
                                ? 'Realizado: la factura de reembolso ya fue adjuntada'
                                : 'Pendiente: falta adjuntar la factura de reembolso'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td class="tx-cell--strong tx-cell--factura">
                        {{ inv.invoiceNumber || '—' }}
                      </td>
                      <td class="th-right tx-nowrap">{{ money(inv.cif) }}</td>
                      <td>{{ inv.laboratorio || '—' }}</td>
                      <td>{{ inv.distribuidor || '—' }}</td>
                      <!-- Fecha de aprobación y monto del impuesto: las pidió
                           el cliente para leer aquí lo mismo que en Pago de
                           Impuestos sin cambiar de pantalla. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        {{ dateOf(g.tramite.departureDate) }}
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                      >
                        <span v-if="g.tramite.taxAmount">
                          {{ money(g.tramite.taxAmount) }}
                        </span>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                      >
                        <span v-if="resumen(g.tramite).count" class="rb-count">
                          {{ resumen(g.tramite).count }}
                        </span>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                      >
                        <strong v-if="resumen(g.tramite).total">
                          {{ money(resumen(g.tramite).total) }}
                        </strong>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <v-switch
                              :input-value="g.tramite.reimbursePaidByTransit"
                              color="#254f87"
                              class="tx-switch"
                              hide-details
                              @change="toggleTransitPays(g.tramite)"
                            ></v-switch>
                          </template>
                          <span>
                            {{
                              g.tramite.reimbursePaidByTransit
                                ? 'Transit adelanta estos pagos y se los cobra al cliente'
                                : 'El cliente paga directo; no entra al estado de cuenta'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <!-- La factura de reembolso de Alegra: su N° (manual,
                           se escribe en el Detalle) y su fecha. El estado de
                           cuenta la lista así y sin el N° no se puede emitir:
                           por eso se avisa aquí cuando falta. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        <template v-if="g.tramite.reimbursementInvoiceDate">
                          <div
                            v-if="g.tramite.reimbursementInvoiceNumber"
                            class="tx-cell--strong"
                          >
                            {{ g.tramite.reimbursementInvoiceNumber }}
                          </div>
                          <div
                            v-else
                            class="tx-warn"
                            title="Escribe el N° de la factura de Alegra en el Detalle"
                          >
                            Falta N° Alegra
                          </div>
                          <div>
                            {{ dateOf(g.tramite.reimbursementInvoiceDate) }}
                          </div>
                        </template>
                        <span
                          v-else
                          class="tx-muted"
                          title="Se fija sola al adjuntar la factura de reembolso"
                        >
                          Al adjuntar factura
                        </span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-actions"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <button
                              class="doc-btn"
                              :class="{
                                'doc-btn--done': resumen(g.tramite).count > 0,
                              }"
                              @click="openDetail(g.tramite)"
                            >
                              <v-icon small>list_alt</v-icon>
                              Detalle
                            </button>
                          </template>
                          <span
                            >Conceptos adelantados, montos y comprobantes</span
                          >
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="!pagination.loading && groups.length === 0">
                    <tr>
                      <td colspan="12" class="empty-state">
                        No hay trámites con los filtros aplicados.
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="pagination.loading">
                    <tr>
                      <td colspan="12" class="empty-state">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="pagination.pages">
          <div class="list-footer">
            <div class="list-footer__count">
              Mostrando {{ groups.length }} de {{ meta.totalGroups }} trámites
              ({{ meta.totalInvoices }}
              facturas)
            </div>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              color="#254f87"
              @input="asyncPagination"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="800" v-if="detail.data" v-model="detail.show">
      <reimbursement-dialog
        :key="detail.key"
        :item="detail.data"
        v-on:close-reimbursement="detail.show = false"
        v-on:changed="loadSummaries"
        v-on:saved="onDetailSaved"
      ></reimbursement-dialog>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar
      v-model="snack.show"
      :timeout="4000"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import loading from './../dialog/DialogLoading'
import reimbursementDialog from './../dialog/DialogReimbursement'
import TxFilter from './../transit/TransitFilter.vue'
import TramiteBand from './../transit/mixins/TramiteBand'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    loading,
    'reimbursement-dialog': reimbursementDialog,
    'tx-filter': TxFilter,
  },
  // Banda del trámite y money(): la misma fuente que Facturas y Transit.
  mixins: [TramiteBand],
  data() {
    return {
      loading: true,
      groups: [],
      meta: { totalGroups: 0, totalInvoices: 0 },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      detail: { show: null, data: null, key: 0 },
      // Resumen por factura: cuántos conceptos y cuánto suman. Se pide en una
      // sola consulta para toda la página, no una por fila.
      summaries: {},
      snack: { show: false, color: 'info', message: '' },
    }
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    // Una fila por TRÁMITE: la fila padre del consolidado (con el CIF sumado)
    // o la factura sola. Es lo que contabilidad cobra.
    tramites() {
      return this.groups.map(g => g.tramite).filter(Boolean)
    },
    invoices() {
      return this.tramites
    },
    pageIds() {
      return this.invoices.map(item => item.id)
    },
    totalPagina() {
      return Object.keys(this.summaries).reduce(
        (acc, k) => acc + this.summaries[k].total,
        0
      )
    },
  },
  methods: {
    dateOf(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—'
    },
    resumen(item) {
      return this.summaries[item.id] || { count: 0, total: 0 }
    },
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    helperPaginate(response) {
      this.groups = (response && response.groups) || []
      this.meta = {
        totalGroups: (response && response.totalGroups) || 0,
        totalInvoices: (response && response.totalInvoices) || 0,
      }
      this.pagination.totalItems = this.meta.totalInvoices
      this.pagination.pages =
        Math.ceil(this.meta.totalGroups / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
      this.loadSummaries()
    },
    loadSummaries() {
      if (!this.pageIds.length) {
        this.summaries = {}
        return
      }
      this.$store
        .dispatch('invoices/getReimbursements', {
          ids: this.pageIds.join(','),
        })
        .then(lines => {
          const acc = {}
          ;(lines || []).forEach(l => {
            // Solo cuenta lo que tiene monto: la línea del impuesto se refleja
            // sola desde Pago de Impuestos y, vacía, no es un adelanto.
            const amount =
              l.amount === null || typeof l.amount === 'undefined'
                ? NaN
                : parseFloat(l.amount)
            if (Number.isNaN(amount)) return
            if (!acc[l.invoiceId]) acc[l.invoiceId] = { count: 0, total: 0 }
            acc[l.invoiceId].count += 1
            acc[l.invoiceId].total += amount
          })
          this.summaries = acc
        })
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'accounting',
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store
          .dispatch('invoices/getConsolidated', filter)
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    openDetail(item) {
      this.detail = {
        data: item,
        show: true,
        key: this.detail.key + 1,
      }
    },
    onDetailSaved() {
      this.detail.show = false
      this.loading = true
      this.asyncPagination().then(() => {
        this.notify('Reembolso actualizado.', 'success')
      })
    },
    toggleTransitPays(item) {
      const next = !item.reimbursePaidByTransit
      item.reimbursePaidByTransit = next
      this.$store
        .dispatch('invoices/updateAccounting', {
          invoiceId: item.id,
          reimbursePaidByTransit: next,
        })
        .then(response => {
          if (!response || (response.status && response.status >= 400)) {
            item.reimbursePaidByTransit = !next
            this.notify('No se pudo actualizar el switch.', 'error')
            return
          }
          this.notify(
            next
              ? 'Transit adelanta el reembolso; entra al estado de cuenta.'
              : 'El cliente paga directo; queda fuera del estado de cuenta.',
            'success'
          )
        })
        .catch(() => {
          item.reimbursePaidByTransit = !next
          this.notify('No se pudo actualizar el switch.', 'error')
        })
    },
    onSearch(params) {
      Object.keys(params).forEach(key => {
        if (params[key] == null || params[key] === '') delete params[key]
      })
      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'accounting',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>

<style scoped src="./../transit/transit-list.css"></style>

<style scoped>
/* El grupo entero (banda + facturas) abre el diálogo del trámite. El realce
   conjunto del grupo viene de transit-list.css. */
.tx-group {
  cursor: pointer;
}

.tx-chip--warn {
  background: #fffbeb;
  color: #92400e;
}
.tx-chip--warn .tx-chip__icon {
  color: #b45309 !important;
}

.rb-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 12px;
  font-weight: 700;
}

.tx-switch {
  margin: 0 !important;
  padding: 0 !important;
}

.doc-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.18s ease;
}
.doc-btn .v-icon {
  color: #64748b !important;
  font-size: 15px !important;
}
.doc-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}
.doc-btn--done {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}
.doc-btn--done .v-icon {
  color: #b45309 !important;
}
/* En Transit la sangría del consolidado va en la primera celda, que es la
   factura; aquí la primera es el semáforo y abarca todo el grupo, así que
   la sangría pasa a la celda de la factura. La regla de la factura se repite
   aunque ya esté en transit-list.css porque debe ir DESPUÉS de anular la
   primera celda: desde la segunda fila el semáforo (rowspan) no está y la
   factura es la primera celda. */
.tx-child-row td:first-child {
  padding-left: 14px;
  border-left: 0;
}
.tx-child-row td.tx-cell--factura {
  padding-left: 22px;
  border-left: 3px solid #cbd5e1;
}
/* Aviso discreto: hay factura adjunta pero falta su N° de Alegra. */
.tx-warn {
  font-size: 12.5px;
  font-weight: 600;
  color: #b91c1c;
}
/* Semáforo: rojo = falta la factura de reembolso, verde = adjuntada. */
.light {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  vertical-align: middle;
}
.light--red {
  background: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.18);
}
.light--green {
  background: #15803d;
  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.18);
}
</style>
